<div id="fachgebiete" class="page-wrapper">

	<app-menu [activeMenuIndex]="6">
	</app-menu>

	<!--<div class="subheader-bar-wrapper">
		<div class="subheader-content">
			<a href="https://www.lsd-diagnostik-partner.de/" target="_blank">
				<div class="subheader-content-text">
					Ihr kostenfreies Testset!
				</div>
			</a>
		</div>
	</div>-->

	<div class="floating-chameleon"></div>

	<div class="title-wrapper">
    <br>
    <h1 class="m-b-10">
			Morbus Fabry
		</h1>
		<h2 class="m-b-40">
			Auffällig unauffällig
		</h2>
    <br>
		<div class="title-description">
			Morbus Fabry ist eine seltene, <a href="morbus-fabry#section-5" class="color-home"><strong>genetisch</strong></a> bedingte
			Stoffwechselerkrankung.<sup class="info-section-text-ref">1</sup> Der Mangel an
			α-Galaktosidase A führt zur <strong>Akkumulation von Globotriaosylceramid</strong> (Gb3) in Geweben
			verschiedener Organe und zu konsekutivem <strong>progredienten Funktionsverlust der Zellen</strong>.<sup class="info-section-text-ref">2</sup>
			Daher ist ein individueller und interdisziplinärer <a href="therapie-login" class="color-home"><strong>Behandlungsansatz</strong></a> bedeutsam.
		</div>
	</div>

	<div class="info-section m-b-0">
		<div class="info-section-block">
			<div class="info-section-circle-center home">
				<div>
					Ohne eine<br>
					<strong>frühzeitige <a href="diagnose" class="color-home">Diagnose</a></strong><br>
					sowie eine<br>
					<strong>angemessene Behandlung</strong><br>
					kann Morbus Fabry einen<br>
					progredienten Verlauf nehmen und zu<br>
					zunehmender Schädigung von Herz,<br>
					Nieren und ZNS und insgesamt zu<br>
					einer schlechten <a href="morbus-fabry#section-7" class="color-home">Prognose</a> für die<br>
					betroffenen Patienten führen.<br>
				</div>
			</div>
		</div>
		<div class="separator normal m-b-20"></div>
	</div>

	<div class="info-section m-t-0">
		<div class="info-section-title">
			Wichtige Fachbereiche für die frühzeitige Diagnose
		</div>
		<div class="info-section-squares">
			<!--<div class="info-section-block info-section-block-1" onclick="location.href='fachgebiete/kardiologie'" style="cursor: pointer;">-->
      <div class="info-section-block info-section-block-1">
				<div class="info-section-image">
					<img src="/assets/img/template/01-fachgebiete/herz.png" />
				</div>
				<div class="info-section-block-title info-section-block-title-md">
					Auffällig unauffällig<br> in der Kardiologie
				</div>
				<div class="info-section-block-text">
					<ul class="bullet-white m-b-40">
						<li>Linksventrikuläre Hypertrophie<br>
							≥ 12 mm ohne Hypertonie/mit<br>
							Hypertonie</li>
						<li>Prominenter Papillarmuskel<sup class="info-section-text-ref">4</sup></li>
						<li>Myokardiale Fibrose</li>
						<li>Arrhythmien<sup class="info-section-text-ref">4,5</sup></li>
					</ul>
				</div>
				<a href="fachgebiete/kardiologie" class="info-section-button button-bottom color-white info-section-button-1">
					Zur Kardiologie →
				</a>
			</div>
			<div class="info-section-block info-section-block-2">
				<div class="info-section-image">
					<img src="/assets/img/template/01-fachgebiete/niere.png" />
				</div>
				<div class="info-section-block-title info-section-block-title-md">
					Auffällig unauffällig<br> in der Nephrologie
				</div>
				<div class="info-section-block-text">
					<ul class="bullet-white m-b-40">
						<li>Unklare Proteinurie<sup class="info-section-text-ref">6</sup></li>
						<li>Progrediente Niereninsuffizienz</li>
						<li>Parapelvine Zysten<sup class="info-section-text-ref">7,8</sup></li>
					</ul>
				</div>
				<a href="fachgebiete/nephrologie" class="info-section-button button-bottom color-white info-section-button-2">
					Zur Nephrologie →
				</a>
			</div>
			<div class="info-section-block info-section-block-3">
				<div class="info-section-image">
					<img src="/assets/img/template/01-fachgebiete/gehirn.png" />
				</div>
				<div class="info-section-block-title info-section-block-title-md">
					Auffällig unauffällig<br> in der Neurologie
				</div>
				<div class="info-section-block-text" onclick="location.href='fachgebiete/neurologie'" style="cursor: pointer;">
					<ul class="bullet-white m-b-40">
						<li>Neuropathische Schmerzen<sup class="info-section-text-ref">9</sup></li>
						<li>Juveniler Schlaganfall (18-55 Jahre)<sup class="info-section-text-ref">10</sup></li>
						<li>Differenzialdiagnose Multiple Sklerose<sup class="info-section-text-ref">11</sup></li>
					</ul>
				</div>
				<a href="fachgebiete/neurologie" class="info-section-button button-bottom color-white info-section-button-3">
					Zur Neurologie →
				</a>
			</div>
			<div class="info-section-block info-section-block-4">
				<div class="info-section-image">
					<img src="/assets/img/template/01-fachgebiete/kind.png" />
				</div>
				<div class="info-section-block-title info-section-block-title-md">
					Auffällig unauffällig<br> in der Pädiatrie
				</div>
				<div class="info-section-block-text">
					<ul class="bullet-white m-b-40">
						<li>Bauchschmerzen, Diarrhö und Übelkeit<sup class="info-section-text-ref">12</sup></li>
						<li>Neuropathische Schmerzen<sup class="info-section-text-ref">12,13</sup></li>
						<li>Hypohidrose</li>
						<li>Angiokeratome</li>
						<li>Cornea verticillata</li>
						<li>Hörstörungen und Vertigo</li>
					</ul>
				</div>
				<a href="https://www.lsd-diagnostik-partner.de/" target="_blank" class="info-section-button color-white button-bottom info-section-button-4">
					Testen Sie jetzt! →
				</a>
			</div>
		</div>
	</div>
	<div class="info-section m-b-0">
    <div class="wrapper-half-center">
      <div class="info-section-image text-center">
        <img src="/assets/img/template/01-fachgebiete/arzt.png" />
      </div>
      <p class="text-center">
        Bei Morbus Fabry können eine Vielzahl
        von <a href="therapie#section-3" class="color-home"><strong>Organen und Organsystemen</strong></a>
        betroffen sein, daher ist eine
        <strong>interdisziplinäre Betreuung</strong> der
        Patienten wichtig. Dazu gehört auch die
        genetische Beratung für den Patienten
        und seine Angehörigen.
      </p>
    </div>
	</div>
</div>





<app-footer>
</app-footer>

<style>
	/*.info-section-container {
		display: flex;
		flex-wrap: wrap;
		width: 1200px;
		margin-bottom: 120px;
	}
	@media only screen and (max-width: 768px) {
		.info-section-container {
			width: calc(100% + 64px);
			margin-bottom: 8px;
		}
	}*/
</style>
